
import React, { useState } from 'react';
import { ChevronLeft, ChevronRight, Quote } from 'lucide-react';
import { Button } from '@/components/ui/button';

const testimonials = [
  {
    id: 1,
    name: 'Guru Priya',
    location: 'Chennai',
    image: 'https://static.vecteezy.com/system/resources/previews/008/442/086/non_2x/illustration-of-human-icon-user-symbol-icon-modern-design-on-blank-background-free-vector.jpg',
    quote: "I had an accident one and half year ago.. consultant with some ortho doctors.. they suggest me to get a surgery.. My last hope is Dr. Loganathan.. his way of treatment Is really different.. it almost cured my dislocation and cracks in ankle... I will post my before and after images of ankle once I completed my treatment... am not here for rating... am sure he will give his best treatment and safest place...",
    condition: 'Dislocation',
    rating: 5
  },
  {
    id: 2,
    name: 'Sabari R',
    location: 'Chennai',
    image: 'https://static.vecteezy.com/system/resources/previews/008/442/086/non_2x/illustration-of-human-icon-user-symbol-icon-modern-design-on-blank-background-free-vector.jpg', 
    quote: "I am suffered from low back pain and knee pain severe. I searched Google in chiropractic treatment in shri varaham swastik centre . I'm going to treatment in shri varaham swastik few days good feel in chiropractic treatment I'm cure low back and knee pain 🙏🙏🙏",
    condition: 'Back Pain',
    rating: 5
  },
  {
    id: 3,
    name: 'Kamalakannan Ragavan',
    location: 'Chennai',
    image: 'https://static.vecteezy.com/system/resources/previews/008/442/086/non_2x/illustration-of-human-icon-user-symbol-icon-modern-design-on-blank-background-free-vector.jpg', 
    quote: "My back of thigh muscle sever pain in 2yrs .but I am treatment in Shri varaham swastik chiropractic centre. Slow by slow Pain is suddenly release. I have thank god and Dr. Loganatha sir 🙏 this center fully traditional treatment",
    condition: 'Muscle Pain',
    rating: 5
  }
];

const TestimonialsSection = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  const nextTestimonial = () => {
    setActiveIndex((current) => (current === testimonials.length - 1 ? 0 : current + 1));
  };

  const prevTestimonial = () => {
    setActiveIndex((current) => (current === 0 ? testimonials.length - 1 : current - 1));
  };

  return (
    <section id="testimonials" className="py-16 md:py-24 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="text-swastik-green font-medium">Patient Success Stories</span>
          <h2 className="section-title mx-auto after:left-1/2 after:-translate-x-1/2">Hear from Our Patients</h2>
          <p className="section-subtitle">
            These testimonials reflect the life-changing results our patients have experienced through our holistic approach to chronic disease management.
          </p>
        </div>

        <div className="max-w-6xl mx-auto">
          <div className="relative bg-gradient-to-r from-swastik-blue/10 to-swastik-lightBlue/10 rounded-lg p-8 md:p-12">
            <div className="absolute top-6 left-6 text-swastik-blue/20">
              <Quote size={80} />
            </div>

            <div className="grid md:grid-cols-3 gap-8">
              {testimonials.map((testimonial, index) => (
                <div 
                  key={testimonial.id}
                  className={`bg-white rounded-lg shadow-lg p-6 transition-all duration-300 transform ${
                    index === activeIndex ? 'scale-105 border-2 border-swastik-blue' : 'scale-95 opacity-70'
                  }`}
                  onClick={() => setActiveIndex(index)}
                >
                  <div className="flex items-center mb-4">
                    <img 
                      src={testimonial.image} 
                      alt={`${testimonial.name} from ${testimonial.location}`} 
                      className="w-16 h-16 rounded-full object-cover"
                    />
                    <div className="ml-4">
                      <h4 className="text-lg font-bold text-gray-900">{testimonial.name}</h4>
                      <p className="text-gray-500">{testimonial.location}</p>
                      <div className="flex mt-1">
                        {[...Array(testimonial.rating)].map((_, i) => (
                          <svg key={i} xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-yellow-500" viewBox="0 0 20 20" fill="currentColor">
                            <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118l-2.8-2.034c-.783-.57-.38-1.81.588-1.81h3.462a1 1 0 00.95-.69l1.07-3.292z" />
                          </svg>
                        ))}
                      </div>
                    </div>
                  </div>
                  <p className="text-gray-600 mb-3">"{testimonial.quote}"</p>
                  <span className="inline-block px-3 py-1 bg-swastik-lightBlue/20 text-swastik-blue text-sm rounded-full">
                    {testimonial.condition} Treatment
                  </span>
                </div>
              ))}
            </div>

            <div className="flex justify-center mt-12 space-x-4">
              <Button 
                variant="outline" 
                size="icon" 
                className="rounded-full" 
                onClick={prevTestimonial}
              >
                <ChevronLeft />
              </Button>
              <div className="flex space-x-2">
                {testimonials.map((_, index) => (
                  <button
                    key={index}
                    className={`w-3 h-3 rounded-full ${
                      index === activeIndex ? 'bg-swastik-blue' : 'bg-gray-300'
                    }`}
                    onClick={() => setActiveIndex(index)}
                  />
                ))}
              </div>
              <Button 
                variant="outline" 
                size="icon" 
                className="rounded-full" 
                onClick={nextTestimonial}
              >
                <ChevronRight />
              </Button>
            </div>
          </div>

          <div className="text-center mt-12">
            <Button className="bg-swastik-blue hover:bg-swastik-blue/90">Read More Success Stories</Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
